// src/pages/AboutPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';

function AboutPage() {
  const { t } = useTranslation();
  
  return (
    <main className="container py-4" role="main">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <article>
            <h1 className="mb-4">{t('about.title')}</h1>
            <section aria-labelledby="purpose">
              <h2 id="purpose" className="h4 mb-3">{t('about.purpose.title')}</h2>
              <p>{t('about.purpose.description')}</p>
            </section>
            
            <section aria-labelledby="features" className="mt-4">
              <h2 id="features" className="h4 mb-3">{t('about.features.title')}</h2>
              <ul role="list">
                {t('about.features.list', { returnObjects: true }).map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </section>

            <section aria-labelledby="contact" className="mt-4">
              <h2 id="contact" className="h4 mb-3">{t('about.contact.title')}</h2>
              <p>
                {t('about.contact.text')}
                <a 
                  href="mailto:support@dmvquiz.app" 
                  className="ms-1"
                  aria-label={t('about.contact.emailLabel')}
                >
                  {t('about.contact.emailText')}
                </a>
              </p>
            </section>
          </article>
        </div>
      </div>
    </main>
  );
}

export default AboutPage;
